// frontend/src/api/bulk.js
import { apiClient } from './index';

const bulkApi = {
  // --- USER METHODS ---
  
  createRequest: async (requestData) => {
    return await apiClient.post('/bulk/', requestData);
  },

  getMyRequests: async () => {
    return await apiClient.get('/bulk/');
  },

  // Phone + email to show on the request form, and which one is locked
  // (the one the account was verified with).
  getContact: async () => {
    return await apiClient.get('/bulk/contact');
  },

  // Number shown on the "Bulk Purchases" tab (quotes not yet opened).
  getUnreadCount: async () => {
    return await apiClient.get('/bulk/unread-count');
  },

  // Customer opened a request - stop counting it as unread.
  markRead: async (id) => {
    return await apiClient.post(`/bulk/${id}/read`);
  },

  getRequestById: async (requestId) => {
    return await apiClient.get(`/bulk/${requestId}`);
  },

  updateStatus: async (requestId, status) => {
    // status: 'accepted' or 'rejected'
    return await apiClient.put(`/bulk/${requestId}/status`, { status });
  },

  // --- ADMIN METHODS ---

  getAllRequestsAdmin: async (status = null) => {
    const url = status ? `/bulk/admin/all?status=${status}` : '/bulk/admin/all';
    return await apiClient.get(url);
  },

  sendQuoteAdmin: async (requestId, quoteData) => {
    // quoteData: { items: [...], admin_notes, valid_until }
    return await apiClient.put(`/bulk/admin/${requestId}/quote`, quoteData);
  },
  
  // --- NEW BULK DELETE ---
  deleteRequestsAdmin: async (requestIds) => {
      return await apiClient.delete('/bulk/admin/delete-bulk', { body: requestIds });
  }
};

export { bulkApi };